"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.createStorages = exports.AcalaTokenProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _storage = require("../../utils/storage");
var _createTokenList = require("./create-token-list");
var _types = require("@acala-network/sdk/types");
var _getChainType = require("@acala-network/sdk/utils/get-chain-type");
var _errors = require("../errors");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const createStorages = api => {
  return {
    foreignAssetLocations: () => _storage.Storage.create({
      api: api,
      path: 'query.assetRegistry.foreignAssetLocations.entries',
      params: []
    }),
    assetMetadatas: () => _storage.Storage.create({
      api: api,
      path: 'query.assetRegistry.assetMetadatas.entries',
      params: []
    }),
    tradingPairs: () => _storage.Storage.create({
      api: api,
      path: 'query.dex.tradingPairStatuses.entries',
      params: []
    })
  };
};
exports.createStorages = createStorages;
class AcalaTokenProvider {
  constructor(api, configs) {
    this.api = void 0;
    this.storages = void 0;
    this.configs = void 0;
    this.chainType = void 0;
    this.tokens$ = void 0;
    this.ready$ = void 0;
    this.api = api;
    this.storages = createStorages(api);
    this.configs = _objectSpread({
      kusd2ausd: true,
      ignoreCase: true
    }, configs);
    this.chainType = (0, _getChainType.getChainType)(this.api.runtimeChain.toString());
    this.ready$ = new _rxjs.BehaviorSubject(false);
    this.tokens$ = new _rxjs.BehaviorSubject({});
    this.initTokens().subscribe({
      next: data => {
        this.tokens$.next(data);
        this.ready$.next(true);
      }
    });
  }
  initTokens() {
    const tradingPairs$ = this.storages.tradingPairs().observable;
    const assetMetadatas$ = this.storages.assetMetadatas().observable;
    const foreignAssetLocations$ = this.storages.foreignAssetLocations().observable;
    return (0, _rxjs.combineLatest)({
      tradingPairs: tradingPairs$,
      assetMetadatas: assetMetadatas$,
      foreignAssetLocations: foreignAssetLocations$
    }).pipe((0, _operators.take)(1), (0, _operators.map)(_ref => {
      let {
        tradingPairs,
        assetMetadatas,
        foreignAssetLocations
      } = _ref;
      return (0, _createTokenList.createTokenList)(tradingPairs, assetMetadatas, foreignAssetLocations, {
        kusd2ausd: !this.configs.kusd2ausd,
        insertLCDOT: this.chainType === _types.ChainType.ACALA || this.chainType === _types.ChainType.MANDALA
      });
    }));
  }
  get isReady$() {
    return this.ready$.pipe((0, _operators.filter)(i => !!i));
  }
  get isReady() {
    return (0, _rxjs.firstValueFrom)(this.isReady$);
  }

  /**
   * @name is TokenEqual
   * @description return true when `a` is equal to `b`'s name or symbol or fullname
   * @param a string
   * @param b Token
   * @param ignoreCase boolean
   * @returns boolean
   */
  isTokenEqual(a, b, ignoreCase) {
    if (ignoreCase === void 0) {
      ignoreCase = true;
    }
    const isEqual = (a, b) => ignoreCase ? a.toLowerCase() === b.toLowerCase() : a === b;
    if (this.configs.kusd2ausd) {
      const upperName = a.toUpperCase();
      if (upperName === 'KUSD' || upperName === 'AUSD') {
        return isEqual(b.display, 'AUSD') || isEqual(b.display, 'KUSD') || isEqual(b.symbol, 'AUSD') || isEqual(b.symbol, 'KUSD') || isEqual(b.name, 'AUSD') || isEqual(b.name, 'KUSD') || isEqual(b.fullname, 'AUSD') || isEqual(b.fullname, 'KUSD');
      }
    }
    return isEqual(b.display, a) || isEqual(b.symbol, a) || isEqual(b.name, a) || isEqual(b.fullname, a);
  }
  subscribeToken(token) {
    const name = (0, _sdkCore.forceToCurrencyName)(token);
    return this.tokens$.pipe((0, _operators.filter)(data => !!data), (0, _operators.map)(tokens => {
      const result = Object.values(tokens).find(item => this.isTokenEqual(name, item));
      if (!result) throw new _errors.CurrencyNotFound(name);
      return result;
    }));
  }
  getToken(token) {
    const name = (0, _sdkCore.forceToCurrencyName)(token);
    const result = Object.values(this.tokens$.getValue() || {}).find(item => this.isTokenEqual(name, item));
    if (!result) throw new _errors.CurrencyNotFound(name);
    return result;
  }
  subscribeTokens(types) {
    return this.tokens$.pipe((0, _operators.map)(data => {
      if (types === undefined) return data || {};
      return Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Object.entries(data).filter(_ref2 => {
        let [, value] = _ref2;
        if (Array.isArray(types)) {
          return types.includes(value.type);
        }
        return value.type === types;
      }));
    }), (0, _operators.shareReplay)(1));
  }
  getAllTokens() {
    if (this.ready$.getValue() === false) {
      console.warn(`__getAllToken need sdk ready`);
    }
    return this.tokens$.getValue();
  }
  getNativeToken() {
    const nativeCurrency = this.api.registry.chainTokens[0];
    return this.getToken(nativeCurrency);
  }
}
exports.AcalaTokenProvider = AcalaTokenProvider;